import {IAmplitudeExperimentVariants} from "../types/IAmplitudeExperimentVariants";
import {IFeatureFlagConfig} from "../types/IFeatureFlagConfig";
import {IResolvedFeatureFlags} from "../types/IResolvedFeatureFlag";

const OFF_VARIANT = "off";

export const resolveFeatureFlags = (configs: IFeatureFlagConfig[], variants: IAmplitudeExperimentVariants): IResolvedFeatureFlags => {
    const result: IResolvedFeatureFlags = {};

    for (const config of configs) {
        const amplitudeVariant = variants[config.id];
        const actualValue = amplitudeVariant?.value ?? null;

        result[config.id] = {
            id: config.id,
            name: config.name,
            variants: config.variants,
            variant: actualValue !== null && config.variants.includes(actualValue) ? actualValue : OFF_VARIANT
        };
    }

    return result;
};
